import { Component, OnInit, ElementRef } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-purchase-payment',
  templateUrl: './purchase-payment.component.html',
  styleUrls: ['./purchase-payment.component.css']
})
export class PurchasePaymentComponent implements OnInit {

  constructor(public ElementRef:ElementRef,private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
  InventoryModel = {
    POInvoiceID:0,
    VendorID: 0,
    AccID: 0,
    BankID: 0,
    FromDate: '',
    ToDate: '',
    POID: 0,
    BalanceAmount:0,
    PaymentMode:"",
    PaymentAmount:0,
    TotalDueInvoiceAmount:0,
    ChequeNo:"",
    ChequeDate:"",
    Remarks:""
}
InvoiceList:any;
BalanceAmount=0;
GetTotal () {
    this.InventoryModel.BalanceAmount = 0;
    this.InventoryModel.PaymentAmount = 0;
  
    for (var i = 0; i < this.InvoiceList.length; i++) {

        this.InventoryModel.PaymentAmount = this.InventoryModel.PaymentAmount + this.InvoiceList[i].Amount;
      
    }
    this.BalanceAmount = this.InventoryModel.TotalDueInvoiceAmount - this.InventoryModel.PaymentAmount;
}
SearchPaymentModel = {
    FromDate: '',
    ToDate: '',
    VendorID: 0,
}
ClearSearchPayment () {
    this.SearchPaymentModel.FromDate = '';
    this.SearchPaymentModel.ToDate = '';
    this.SearchPaymentModel.VendorID = 0;
}
PaymentList:any;
GetAllPaymentList () {
    this.spinnerService.show();
    this.stockService.GetAllPaymentList(JSON.stringify(this.SearchPaymentModel)).subscribe( (response)=> {
        this.PaymentList = response.PaymentList;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
    })
}
ViewPaymentModel = {
    PaymentID: 0,
    PaymentAmount: 0,
    ChequeDate: '',
    Remarks: '',
    PaymentMode: '',
    ChequeNo: '',
    BranchName: '',
    CreatedOn: '',
    CancelRemarks: '',
    VendorName: '',

}
ViewPaymentDetails (item) {
    this.ViewPaymentModel.PaymentID = item.PaymentID;
    this.ViewPaymentModel.PaymentAmount = item.PaymentAmount;
    this.ViewPaymentModel.ChequeDate = item.ChequeDate;
    this.ViewPaymentModel.Remarks = item.Remarks;
    this.ViewPaymentModel.PaymentMode = item.PaymentMode;
    this.ViewPaymentModel.ChequeNo = item.ChequeNo;
    this.ViewPaymentModel.BranchName = item.BankName;
    this.ViewPaymentModel.CreatedOn = item.CreatedOn;
    this.ViewPaymentModel.VendorName = item.VendorName;
}
ClearPaymentView () {
    this.ViewPaymentModel.PaymentID = 0;
    this.ViewPaymentModel.PaymentAmount = 0;
    this.ViewPaymentModel.ChequeDate = '';
    this.ViewPaymentModel.Remarks = '';
    this.ViewPaymentModel.PaymentMode = '';
    this.ViewPaymentModel.ChequeNo = '';
    this.ViewPaymentModel.BranchName = '';
    this.ViewPaymentModel.CreatedOn = '';
    this.ViewPaymentModel.VendorName = '';
    this.ViewPaymentModel.CancelRemarks = '';
}
CancelPayment () {
  this.spinnerService.show();
    this.stockService.CancelPayment(JSON.stringify(this.ViewPaymentModel)).subscribe( (data)=> {
      this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
        this.ClearPaymentView();
        this.GetAllPaymentList();
        this.GetInvoiceList();
      
    });
}
PaymentModeList:any;
GetPaymentMode () {

    this.lookupService.GetLookupsList('PaymentMode', '').subscribe( (data)=> {
        this.PaymentModeList = data.LookupItems;

    });
};
PONumberList:any;
GetPONumber () {
    var item = {
        ItemId: this.InventoryModel.VendorID,
    }
    this.lookupService.GetLookupsList('PONumberByVendor', JSON.stringify(item)).subscribe( (data)=> {
        this.PONumberList = data.LookupItems;
        this.PONumberList.splice(0, 1);
    });
};
Clear () {
    //this.InventoryModel.VendorID = '0';
    this.InventoryModel.PaymentMode = "";
    this.InventoryModel.TotalDueInvoiceAmount = 0;       
    this.InventoryModel.PaymentAmount = 0;
    this.InventoryModel.BalanceAmount = 0;
    this.InventoryModel.BankID = 0;
    this.InventoryModel.ChequeNo = '';
    this.InventoryModel.ChequeDate = '';
    this.InventoryModel.Remarks = '';     
    this.InventoryModel.POInvoiceID = 0;
    this.InventoryModel.AccID = 0;
    this.BalanceAmount = 0;
    this.InvoiceList = {};
    this.Submitted = false;
}
Submitted = false;
GetInvoiceList () {
    this.spinnerService.show();
    this.stockService.GetInvoiceList(JSON.stringify(this.InventoryModel)).subscribe( (response)=> {
        this.InvoiceList = response.InvoiceList;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
        this.GetTotalInvoiceAmount();
    })
};
GetTotalInvoiceAmount () {
    var TotalDueInvoiceAmount = 0;
    for (var i = 0; i < this.InvoiceList.length; i++) {
        TotalDueInvoiceAmount = TotalDueInvoiceAmount + (this.InvoiceList[i].InvoiceAmount - this.InvoiceList[i].PaidAmount)
    }
    this.InventoryModel.TotalDueInvoiceAmount = TotalDueInvoiceAmount;
}
GetBalanceAmount () {
    this.BalanceAmount = this.InventoryModel.TotalDueInvoiceAmount - this.InventoryModel.PaymentAmount;

}
CalculateInvoiceAmount () {
    var TotalDueAmount = 0;
    var PaymentAmount = this.InventoryModel.PaymentAmount;

    for (var i = 0; i < this.InvoiceList.length; i++) {
        TotalDueAmount = (this.InvoiceList[i].InvoiceAmount - this.InvoiceList[i].PaidAmount)
        if (PaymentAmount > TotalDueAmount) {
            PaymentAmount = PaymentAmount - TotalDueAmount;
            this.InvoiceList[i].Amount = TotalDueAmount;

        } else {

            this.InvoiceList[i].Amount = PaymentAmount;
            PaymentAmount = 0;

        }

    }
    this.GetBalanceAmount();
}

 Validation() {
    return this.InventoryModel.VendorID == 0 ||  this.InventoryModel.PaymentMode == '' || this.InventoryModel.PaymentMode == "" || this.InventoryModel.AccID == 0
};

SavePOPayment (valid) {
    
    var CheckAmount = true;
    for (var i = 0; i < this.InvoiceList.length; i++) {
        if (this.InvoiceList[i].Amount >this.InvoiceList[i].DueAmount) {
            CheckAmount = false;
        }
        

    }
    this.Submitted = true;
    if (valid && !this.Validation() && CheckAmount) {
       
       this.spinnerService.show();
        this.stockService.SavePOPayment(JSON.stringify(this.InventoryModel), JSON.stringify(this.InvoiceList)).subscribe( (response)=> {
          this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(response);
            if (response.webResponse.Status) {
                this.Clear();
                this.GetInvoiceList();
                this.GetAllPaymentList();
            }
        });
    }
}
VendorList:any;
GetAllVendor () {
    this.lookupService.GetLookupsList('Vendor', '').subscribe( (data)=> {
        this.VendorList = data.LookupItems;
    });
}
BankList:any;
GetAllBank () {
    this.lookupService.GetLookupsList('BankName', '').subscribe( (data)=> {
        this.BankList = data.LookupItems;

    });
};
BankAccList:any;
GetBankAcc () {
    this.lookupService.GetLookupsList('BankAcc', '').subscribe( (data)=> {
        this.BankAccList = data.LookupItems;
        this.BankAccList.splice(0, 1)
    });
};
CashAccList:any;
GetCashkAcc () {
    this.lookupService.GetLookupsList('CashAcc', '').subscribe( (data)=> {
        this.CashAccList = data.LookupItems;
        
    });
};

  ngOnInit() {
    this.GetBankAcc();
    this.GetCashkAcc();
    this.GetAllVendor();
    this.GetPaymentMode();
    this.GetAllBank();
    this.GetAllPaymentList();
  }

}
